/**
 * Helper: bouw thumb/full WebP-paden vanuit een PNG-pad.
 * Verwacht een pad als '/story-images/foo.png' en retourneert:
 *   - thumb: '/story-images/foo_thumb.webp' (klein, voor library covers ~480px)
 *   - full:  '/story-images/foo.webp'        (max 1280px, voor StoryReader)
 * Bij niet-PNG of leeg pad: gewoon het origineel teruggeven.
 */
export const optimizedImageUrl = (originalUrl, variant = 'thumb') => {
  if (!originalUrl || typeof originalUrl !== 'string') return originalUrl;
  if (!originalUrl.toLowerCase().endsWith('.png')) return originalUrl;
  const base = originalUrl.slice(0, -4); // strip ".png"
  if (variant === 'thumb') return `${base}_thumb.webp`;
  if (variant === 'full')  return `${base}.webp`;
  return originalUrl;
};
